import React, { FC } from "react"
import { useDropClose } from "../../../hooks"
import {
  shuffle,
  linear,
  repeatOne,
  repeat,
} from "../../../store/actions/audio"
import { connect } from "react-redux"

const PlayModeDrop: FC<{
  shuffle: Function
  linear: Function
  repeat: Function
  repeatOne: Function
}> = ({ shuffle, linear, repeat, repeatOne }) => {
  useDropClose()

  return (
    <div
      className="play-mode"
      uk-dropdown="pos: top-center; mode: click;delay-hide: 100"
      id="play-mode"
    >
      <ul className="uk-nav uk-dropdown-nav">
        <li onClick={() => shuffle()}>
          <span>Shuffle</span>
        </li>
        <li onClick={() => linear()}>
          <span>Linear</span>
        </li>
        <li onClick={() => repeatOne()}>
          <span>Repeat one</span>
        </li>
        <li onClick={() => repeat()}>
          <span>Repeat all</span>
        </li>
      </ul>
    </div>
  )
}

export default connect(null, { shuffle, linear, repeat, repeatOne })(
  PlayModeDrop
)
